import { EnvConfiguration } from "./AppConfiguration";

export const staging: EnvConfiguration = {
    api: "https://app-idsplatform-api-stg.azurewebsites.net/",
    assets: "https://stidsplatformstg.blob.core.windows.net/assets/",
    canonical: "https://stidsplatformstg.z6.web.core.windows.net",
    auth: {
        audience: "https://app-idsplatform-api-stg.azurewebsites.net/",
        domain: "bimids.eu.auth0.com",
        clientId: "8niBsC1pl8qzrcCFRoyQm3aVNXZECLzH",
        logoutTo: `https://${window.location.hostname}`,
        scope: "openid email profile offline_access read:current_user update:current_user_metadata admin:access",
    },
    algolia: {
        appId: "OKRNWEA4OH",
        apiKey: "4527e3ddd4c483ae933b1e9381495de2",
        index: "bimids-stg",
    },
    bimq: {
        clientId: "Buildwise",
        redirectUri: `https://${window.location.hostname}/bimq-auth-callback`,
        authorizeEndpoint: "https://server.bim-q.de/oauth/authorize",
    },
    sentry: {
        dsn: "https://93ed3e0cbdc54aad8409e9a8d6c3b321@o399431.ingest.sentry.io/4504604448129024",
        env: "staging",
        sampleRate: 1.0,
        enableLogs: false,
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 0.0,
    },
};
